import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {AuthTokenService} from '../shared/services/auth-token.service';
import {UserLoginModel} from '../models/user/user-login.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {

  loader: boolean = false;
  loginForm: FormGroup;
  userLoginModel = new UserLoginModel();

  constructor(private fb: FormBuilder, private authTokenService: AuthTokenService, private router: Router) {
    this.loginForm = this.fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.maxLength(50), CustomValidators.email])],
      'password': [null, Validators.compose([Validators.required, Validators.maxLength(50)])]
    });
  }

  ngOnInit() {
  }

  submitLoginForm(e) {
    e.stopPropagation();
    for (const c in this.loginForm.controls) {
      this.loginForm.controls[c].markAsTouched();
    }


    if (this.loginForm.valid) {
      this.loader = true;
      this.authTokenService.login(this.userLoginModel, false)
        .subscribe(
          (response) => {
            this.loader = false;
            this.router.navigate(['surveys']);
          },
          (error) => {
            this.loader = false;
            // console.log(error);
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts